import { apiService } from '@api';
import { createModuleView } from '@/helpers/storeFactories/read/readStoreAllItemsFactory';

const STORE_NAME = 'partners';

const store = createModuleView(
    STORE_NAME,
    {
        get: apiService.user.partners.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: 99,
        },
    },
    {
        getters: {
            getPartnersList: (state) => state.list,
            getPartnersListIds: (state) => {
                return state.list.map((element) => element.id);
            },
            hasMultiplePartners: (state) => state.list > 1,
        },
    }
);

export default store;
